/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DocumentResponse } from './DocumentResponse';
import {
    DocumentResponseFromJSON,
    DocumentResponseFromJSONTyped,
    DocumentResponseToJSON,
} from './DocumentResponse';

/**
 * 
 * @export
 * @interface ChunkResponse
 */
export interface ChunkResponse {
    /**
     * 
     * @type {string}
     * @memberof ChunkResponse
     */
    message: string;
    /**
     * 
     * @type {DocumentResponse}
     * @memberof ChunkResponse
     */
    document: DocumentResponse;
}

/**
 * Check if a given object implements the ChunkResponse interface.
 */
export function instanceOfChunkResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "document" in value;

    return isInstance;
}

export function ChunkResponseFromJSON(json: any): ChunkResponse {
    return ChunkResponseFromJSONTyped(json, false);
}

export function ChunkResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChunkResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
        'document': DocumentResponseFromJSON(json['document']),
    };
}

export function ChunkResponseToJSON(value?: ChunkResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'document': DocumentResponseToJSON(value.document),
    };
}

